import { useEffect, useMemo, useState } from "react";

import styles from "./AssessmentManager.module.css";
import { useFilters, useGlobalFilter, useSortBy, useTable } from "react-table";
import { isStandardUserValue, isSuperuserValue } from "../../access/access";
import Loading from "../../components/Loading/Loading";

// import { allPeriodsDetails } from './getAllPeriodsDetailsResponse';
import SubmitButton from "../../components/controls/SubmitButton/SubmitButton";
import GenericModal from "../../UI/GenericModal";
import { useHistory } from "react-router-dom";
import { AssessmentServiceApi } from "../../service/api/AssessmentServiceApi";

const AssessmentManager = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [showFreezeConfButtons, setShowFreezeConfButtons] = useState(false);
  // const [freezeUpdateIsLoading, setFreezeUpdateIsLoading] = useState([])
  const [error, setError] = useState();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();

  const assessmentServiceApi = new AssessmentServiceApi();

  // const modalDataHandler = (title, message, modType, action) => {
  //   setModalAction(() => action );
  //   setModalTitle(title);
  //   setModalMessage(message);
  //   setModalShow(true);
  //   setModalType(modType);
  // }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  const editScore = (fiscalYear, period) => {
    setIsLoading(true);
    history.push(`/assessment-manager/override?fiscalYear=${fiscalYear}&period=${period}`);
  };


  const tableColumns = useMemo(() => COLUMNS, []);

  const {
    // these are functions and arrays that the useTable hook has given to us to enable easy table creation
    // we need to use all of these for it to work
    getTableProps, // it's a function that needs to be destructured on the table tag
    getTableBodyProps, // comment
    headerGroups, // contains the column heading information which belongs in the thead tag of the table
    rows, // comment
    columns,
    prepareRow, // comment
    state,
    setGlobalFilter,

  } = useTable(
    {
      columns: tableColumns,
      data: tableData, // tableData
      initialState: {
        // sortBy: [
        //   {
        //     id: 'fiscalYear',
        //     desc: true
        //   }
        // ]
      },
      // autoResetGlobalFilter: false,
      // autoResetPage: false,
    },
    useFilters,
    useGlobalFilter,
    useSortBy
  );

  const { globalFilter } = state;

  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    let mounted = true;
    setShowFreezeConfButtons(true);

    assessmentServiceApi.getAssessment((error, allPeriodsDetails) => {
      if (mounted) {
        if (!error) {
          console.log("assessment management", allPeriodsDetails);
          console.log("period management columns: ", tableColumns);
          setTableData(formatAssessmentsHandler(allPeriodsDetails));
          setIsLoading(false);
        } else {
          setError(() => {
            throw new Error("");
          })
        }
      }
    })
    return () => {
      mounted = false;
    }
  }, []);

  const formatAssessmentsHandler = (assessments) => {
    const tData = assessments.map((item) => {
      return {
        fiscalYear: item.fiscalYear,
        // period: item.period,
        period: {
          id: item.period.id,
          name: item.period.name
        },
        frozen: item.frozen,
        editable: item.editable,
        // checklist_count: item.checklist_count,
      }
    })
    return tData;
  }

  const openModalHandler = (fiscalYear, period, frozen) => {
    console.log("frozen: ", frozen)
    console.log("fiscalYear: ", fiscalYear)
    console.log("periodId: ", period.id)
    modalDataHandler("Toggle freeze state", `${frozen ? 'Unfreeze' : 'Freeze'} period ${period.name} (${fiscalYear})?`, 'confirmation', () => updateFreezeStateHandler(fiscalYear, period.id, frozen))
  }

  const updateFreezeStateHandler = (fiscalYear, periodId, frozen) => {
    setShowFreezeConfButtons(false);
    console.log("updateFreezeStateHandler")
    // setTimeout(() => {
    //   setShowFreezeConfButtons(true);
    // }, 2000)
    // console.log("updateFreezeStateHandler frozen: ", frozen)
    // console.log("updateFreezeStateHandler period: ", periodId)
    // console.log("updateFreezeStateHandler fiscalYear: ", fiscalYear)
    assessmentServiceApi.freezeAssessment(fiscalYear, periodId, !frozen, (error, data) => {
      if (!error) {
        assessmentServiceApi.getAssessment((getError, allPeriodsDetails) => {
          if (!getError) {
            console.log("assessment management", allPeriodsDetails);
            console.log("period management columns: ", tableColumns);
            setTableData(formatAssessmentsHandler(allPeriodsDetails));
            setShowFreezeConfButtons(true);
          } else {
            setError(() => {
              throw new Error("");
            })
          }
        })
        console.log("responseData: ", data);
      } else {
        setShowFreezeConfButtons(false);
        modalDataHandler(`Error ${(error.response ? error.response.statusCode : "")}`, "Error! The freeze state could not be updated!", 'error', () => setModalShow(false));
      }
    })
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
    setModalAction(action ? () => action : null);
  }

  return (
    <div className={`d-flex justify-content-center position-relative outerContainer`}>
      <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
      {/* <div className={`${styles.backdrop} ${showFreezeConfButtons ? "visible" : "invisible"}`} 
        onClick={closeModalHandler}>
      </div> */}
      {!isLoading && <table {...getTableProps()} className={styles.tableStyle}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                // <th {...column.getHeaderProps()}>
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  <div className="h-100 position-relative">
                    <div className="" >
                      {column.render("Header")}
                      &nbsp;
                      <div className={column.isSorted ? (column.isSortedDesc ? styles.descOrder : styles.ascOrder) : ' '}></div>
                    </div>
                    {column.canFilter ? <div style={{ height: "15px" }}></div> : ""}
                    <div className={`${styles.filter} position-absolute bottom-0`} style={{ left: "10%" }}>{column.canFilter ? column.render('Filter') : null}</div>
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            // console.log("row: ", row)
            // let rowId = row.cells.filter(cell => cell.column.id === "id")[0].value;
            return (
              <tr {...row.getRowProps()}
                onClick={() => {
                  // console.log("show cells: ", row.cells)
                  // showButtonsHandler(row.cells)
                }}
              // onMouseEnter={(e) => {
              //   showDriversDetailsButton(e, rowId);
              //   // showInfoIcon(e);
              // }}
              // onMouseLeave={(e) => {
              //   hideDriversDetailsButton(e, rowId);
              //   // hideInfoIcon(e);
              // }}
              // className={`${selectedRecordId === rowId ? (showButtons && styles.active) : ""}`}
              >
                {row.cells.map((cell, index) => (
                  <td {...cell.getCellProps()} className="text-center" key={index}>
                    {/* {(cell.column.id === 'id') && (
        <button 
          className={`${styles.driverDetailsButton} ${(rowEnteredByMouse === rowId && driversDetailsButtonIsVisible) ? 'visible' : 'invisible'}`}
          onClick={() => getChecklistDriversHandler(rowId)}>
      
        View drivers Info</button>
      )} */}
                    {/* {console.log("row row:", row)} */}
                    {/* {cell.render("Cell")} */}

                    {(cell.column.id !== "action" && cell.column.id !== "scores") ? (
                      cell.render("Cell")
                    ) : (
                      showFreezeConfButtons ? (
                        cell.column.id === "action" ? (
                          <SubmitButton
                            click={() => openModalHandler(row.original.fiscalYear, row.original.period, row.original.frozen)}
                            disabled={row.original.editable === false}
                            reducedFontSize={true}
                            style={{ width: "8em" }}
                          >
                            {row.values.frozen === "Yes" ? "Unfreeze" : "Freeze"}
                          </SubmitButton>
                        ) : (
                          null
                          /*
                          <SubmitButton
                            click={() => {
                              console.log("Fiscal year: " + row.original.fiscalYear)
                              console.log("Period: ", row.original.period.name)
                              editScore(row.original.fiscalYear, row.original.period.name)
                            }}
                            reducedFontSize={true}
                            style={{ width: "8em" }}
                          >
                            Override
                          </SubmitButton>
                          */
                        )
                      ) : (
                        <Loading size={"2.4em"} />
                      )
                    )}
                  </td>
                ))}

              </tr>
            );
          })}
        </tbody>
      </table>}
      {isLoading && <Loading />}
    </div>
  );
}

export default AssessmentManager;

const COLUMNS = [
  {
    Header: "Fiscal Year",
    Footer: "Fiscal Year",
    accessor: "fiscalYear",
    Filter: "",
    disableFilters: true,
    disableSortBy: true,
    canFilter: false
  },
  {
    Header: "Period",
    Footer: "Period",
    // accessor: "period",
    id: "period",
    accessor: row => row.period.name,
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },
  {
    Header: "Frozen",
    Footer: "frozen",
    // accessor: "frozen",
    id: "frozen",
    accessor: row => row.frozen ? "Yes" : "No",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },
  // {
  //   Header: "Evaluated Checklist Count",
  //   Footer: "Evaluated Checklist Count",
  //   accessor: "checklist_count",
  //   Filter: "",
  //   disableFilters: true,
  //   disableSortBy: true
  // },
  {
    Header: "Action",
    Footer: "Action",
    // accessor: "action"
    id: "action",
    accessor: row => row.frozen ? "Yes" : "No",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },

  /*
  {
    Header: "Scores",
    Footer: "Scores",
    // accessor: "action"
    id: "scores",
    accessor: row => row.frozen ? "Yes" : "No",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },
  */
];